var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.618 16.6091C16.1026 16.6091 18.9274 13.7843 18.9274 10.2997C18.9274 6.81506 16.1026 3.99023 12.618 3.99023C9.13342 3.99023 6.30859 6.81506 6.30859 10.2997C6.30859 13.7843 9.13342 16.6091 12.618 16.6091Z",
    stroke: "black",
    strokeWidth: 1.57736,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05469 22.1292C4.02433 20.4509 5.41856 19.0572 7.09734 18.0883C8.77611 17.1194 10.6803 16.6094 12.6186 16.6094C14.5569 16.6094 16.4611 17.1195 18.1398 18.0884C19.8186 19.0574 21.2128 20.451 22.1824 22.1294",
    stroke: "black",
    strokeWidth: 1.57736,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourResults);
export default __webpack_public_path__ + "static/media/YourResults.d4f61a158ee2d62819375c5383b1e8f5.svg";
export { ForwardRef as ReactComponent };